import { createTheme } from '@mui/material/styles'
// import FFF_Tusj from '@/fonts/fff-tusj-webfont.woff2'
import { grey } from '@mui/material/colors'

export const portfolioTheme = createTheme({
    root: {
        flexGrow: 1,
    },
    typography: {
        allVariants: {
            fontFamily: 'Doto, Helvetica, Arial, sans-serif',
            color: '#ebebeb',
        },
        h1: {
            fontFamily: 'Doto, Helvetica, Arial, sans-serif',
            fontSize: '3rem',
            fontDisplay: 'swap',
        },
        h2: {
            fontFamily: 'Doto, Helvetica, Arial, sans-serif',
            fontSize: '1.75rem',
            fontDisplay: 'swap',
        },
        h3: {
            fontFamily: 'Doto, Helvetica, Arial, sans-serif',
            fontSize: '1rem',
            lineHeight: '2rem',
            marginTop: '0.3rem',
        },
        body1: {
           fontSize: '1rem',
           lineHeight: '1.3rem',
           color: '#aaa',
           fontFamily: 'Doto, Helvetica, Arial, sans-serif',
        },
        body2: {
           fontSize: '0.875rem',
           color: '#aaa',
           fontFamily: 'Lato, Helvetica, Arial, sans-serif',
           fontWeight: 300,
        },
    },
    components: {
        // MuiCssBaseline: {
        //     styleOverrides: `
        //         @font-face {
        //             font-family: 'FFF_Tusj';
        //             font-style: normal;
        //             src: url(${FFF_Tusj}) format('woff2');
        //         }
        //     `,
        // },
        MuiSkeleton: {
            styleOverrides: {
                root: {
                    backgroundColor: grey[700],
                },
            },
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    padding: 0,
                    backgroundColor: 'rgba(0,0,0,0)',
                },
            },
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    padding: 0,
                },
            },
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    paddingLeft: 0,
                    paddingRight: '46px'
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: '#1D1D1D',
                    color: '#fff',
                    borderRadius: '1rem',
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    backgroundColor: '#1D1D1D',
                    color: '#fff',
                    paddingTop: '0.625rem',
                    paddingBottom: '0',
                    paddingRight: '0.625rem',
                    paddingBottom: '0.7rem',
                    borderBottom: '1px dashed #828282'
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    backgroundColor: '#1D1D1D',
                    color: '#aaa',
                    marginTop: '1.5rem',
                },
                dividers: {
                    paddingTop: 0,
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    backgroundColor: '#21D1D1D',
                    color: '#aaa',
                    borderTop: '1px dashed #828282'
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: 'Lato, Helvetica, arial, sans-serif',
                    color: '#aaa',
                    borderColor: '#666',
                    borderRadius: '0.5rem',
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: '#666',
                    borderStyle: 'dashed',

                    "&:before": {
                        borderColor: '#666',
                    },
                    "&:after": {
                        borderColor: '#666',
                    },
                },
            },
        },
    },
})
